<template>
  <v-app>
    <Header :layout="'userLayout'"></Header>
    <router-view></router-view>
  </v-app>
</template>

<script type="text/javascript">
import Header from "../../../../components/Header/Header";
export default {
  name: "UsersLayout",
  components: {Header},
  created() {
    if(this.$route.name === "LoginMain") {
      this.headerLeftAuto = true;
    }
  },
  data() {
    return {
      hidePreloader: true,
      headerLeftAuto: false
    }
  }
}
</script>